import { useState, useEffect } from 'react';

/**
 * 移动端断点检测 hook。
 * 手机 = max-width: 767px(Tailwind `md` 断点以下),与全局移动端适配约定一致。
 * 用 matchMedia 监听,窗口尺寸变化 / 旋转屏幕时自动更新。
 */
export function useIsMobile(query = '(max-width: 767px)'): boolean {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [isMobile, setIsMobile] = useState<boolean>(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    // Safari < 14 用 addListener/removeListener,新浏览器用 addEventListener
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return isMobile;
}

export default useIsMobile;
